import React, { useState,useRef  } from 'react';
// import { Card, Button, Form, Alert, Tabs, Tab, Spinner } from 'react-bootstrap';
import { Card, Button, Alert, Tabs, Tab, Spinner } from 'react-bootstrap';
import { migrateUsersApi, migrateProjectsApi, migrateRolesApi } from '../../services/adminApi';
import { FiUploadCloud,FiDownload,FiFileText } from 'react-icons/fi';
import Swal from 'sweetalert2';
import './MigrationPage.css';

const MigrationPage = () => {
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('users');
    const fileInputRef = useRef(null);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleMigrate = async () => {
        if (!file) return Swal.fire('Error', 'Please select a CSV file', 'error');

        const formData = new FormData();
        formData.append('file', file);

        try {
            setLoading(true);
            let res;
            if (activeTab === 'users') {
                res = await migrateUsersApi(formData);
            } else if (activeTab === 'projects') {
                res = await migrateProjectsApi(formData);
            } else if (activeTab === 'roles') {
                res = await migrateRolesApi(formData);
            }

            if (res.data.success) {
                Swal.fire('Success', `${res.data.count} records imported to ${activeTab}!`, 'success');
            }
            setFile(null);
        } catch (err) {
            Swal.fire('Error', err.response?.data?.message || 'Migration Failed', 'error');
        } finally {
            setLoading(false);
        }
    };

    const downloadSampleCsv = () => {

    let csvContent = '';
    let fileName = '';

    if (activeTab === 'users') {

        fileName = 'users-sample.csv';

        csvContent =
    `full_name,email,password,mobile_no,alternate_mobile_no,profile_image_url,education_level,talents,date_of_birth,gender,nationality,country_of_residence,preferred_currency,weight_kg,height_cm,eyes_color,skin_type,body_type,hair_type,hair_color,about_yourself,address_type,pin_code,address_line1,address_line2,state,district,role,is_verified,is_suspended,role_code,joget_user_id,joget_profile_id,facebook_url,instagram_url,linkedin_url,twitter_url,youtube_url,imdb_url,whatsapp_no,pan_number,aadhar_number,agency_name,website,company_incorporation_date,specialization,about_agency,gst_number,special_category,sports_type,esports_type,driving_type,people_appearance_list,know_more_count
Rahul Sharma,rahul@test.com,123456,9876543210,9876543211,https://test.com/profile.jpg,Graduate,Actor,1998-05-20,Male,Indian,India,INR,70,175,Brown,Fair,Athletic,Straight,Black,Professional Actor,Primary,110001,Connaught Place,Block A,Delhi,New Delhi,Candidate,1,0,300,U001,P001,https://fb.com/rahul,https://instagram.com/rahul,https://linkedin.com/in/rahul,https://twitter.com/rahul,https://youtube.com/rahul,https://imdb.com/rahul,9876543210,ABCDE1234F,123412341234,,,,,,GST001,Sports,Cricket,,Car Driving,Tall,10`;
    }

    if (activeTab === 'projects') {

        fileName = 'projects-sample.csv';

        csvContent =
    `joget_project_id,project_name,project_type,director_name,producer_name,program_language,shoot_location_country,start_date,end_date,telecast_channel,type_of_genres,more_details,meta_title,meta_keywords,meta_description,project_image,shoot_locations_json,locations_summary_json,joget_user_id,request_data,status,created_by
P001,Web Series One,Web Series,Rohit Kumar,Amit Sharma,Hindi,India,2025-01-01,2025-06-30,Netflix,Drama,Sample Project Description,Web Series Meta Title,webseries drama ott,Web Series Meta Description,https://test.com/project1.jpg,"[{""pincode"":""110001"",""addressLine1"":""Connaught Place"",""state"":""Delhi"",""district"":""New Delhi""}]","[{""district"":""New Delhi"",""state"":""Delhi"",""pincode"":""110001""}]",U001,,active,1`;
    }

    if (activeTab === 'roles') {

        fileName = 'roles-sample.csv';

        csvContent =
    `audition_type,joget_role_id,role_name,role_category,project_joget_id,shoot_location,required_talent,required_gender,required_language,required_nationality,required_dialect,required_experience_level,required_skin_color,required_age,required_hair_color,required_body_type,required_waist_size,required_chest_size,required_hair_type,required_height,required_eye_color,special_category,sports_type,esports_type,driving_type,people_appearance_list,role_description,role_scene,story_line,character_sketch,role_script,meta_title,meta_keywords,meta_description,audition_locations_json,status,created_by,joget_user_id,request_data,final_amount
Online,R001,Lead Hero,Main Cast,P001,Mumbai,Actor,Male,Hindi,Indian,Mumbai,Experienced,Fair,25-35,Black,Athletic,32,40,Straight,175,Brown,Sports,Cricket,,Car Driving,Tall,Hero Character,Introduction Scene,Hero Story,Strong Character,Sample Script,Hero Meta Title,hero lead actor,Hero Meta Description,"[{""city"":""Mumbai"",""state"":""Maharashtra""}]",active,1,U001,,50000`;
    }

    const blob = new Blob(
        [csvContent],
        { type: 'text/csv;charset=utf-8;' }
    );

    const link = document.createElement('a');

    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
};

const getMigrationGuide = () => {
    if (activeTab === "users") {
return `
Always download and use new sample file
Steps to bulk upload Users
1. Firstly, read notes carefully.
2. Download sample CSV file.
3. Create/Edit CSV file as explained below.
Note - * Indicates Mandatory Fields
full_name * -> Full Name of User.
email * -> Email Address.
password * -> Login Password.
mobile_no * -> Mobile Number.
alternate_mobile_no -> Alternate Mobile Number.
profile_image_url -> Profile Image URL.
education_level -> Education Qualification.
talents -> Actor, Model, Singer etc.
date_of_birth -> YYYY-MM-DD
Example: 1998-05-20
gender -> Male / Female / Other.
nationality -> Nationality.
country_of_residence -> Country Name.
preferred_currency -> INR / USD.
weight_kg -> Weight in KG.
height_cm -> Height in CM.
eyes_color -> Eye Colour.
skin_type -> Skin Type.
body_type -> Body Type.
hair_type -> Hair Type.
hair_color -> Hair Colour.
special_category -> Special Category.
sports_type -> Sports Skill.
esports_type -> Esports Skill.
driving_type -> Driving Skill.
people_appearance_list -> Appearance Type.
about_yourself -> User Description.
address_type -> Primary / Secondary.
pin_code -> Pincode.
address_line1 -> Address Line 1.
address_line2 -> Address Line 2.
state -> State Name.
district -> District Name.
role -> Candidate / Director-Producer / Casting Director / Admin
role_code -> 300 = Candidate, 200 = Director-Producer, 400 = Casting Director, 100 = Admin
is_verified ->0 = No 1 = Yes
is_suspended -> 0 = No 1 = Yes
joget_user_id -> Unique User ID.
joget_profile_id -> Unique Profile ID.
facebook_url -> Facebook URL.
instagram_url -> Instagram URL.
linkedin_url -> LinkedIn URL.
twitter_url -> Twitter URL.
youtube_url -> YouTube URL.
imdb_url -> IMDb URL.
whatsapp_no -> WhatsApp Number.
pan_number -> PAN Number.
aadhar_number -> Aadhaar Number.
agency_name -> Agency Name.
website -> Website URL.
company_incorporation_date -> YYYY-MM-DD
specialization -> Agency Specialization.
about_agency -> Agency Description.
gst_number -> GST Number.
know_more_count -> Numeric Value.
Note: Do not change column names. Duplicate User IDs are not allowed. `;
}
   if (activeTab === "projects") {
return ` Always download and use new sample file
Steps to bulk upload Projects
1. Firstly, read notes carefully.
2. Download sample CSV file.
3. Create/Edit CSV file as explained below.
Note - * Indicates Mandatory Fields
joget_project_id * -> Unique Project ID.
project_name * -> Project Name.
project_type * -> Movie / Web Series / TV Show.
director_name -> Director Name.
producer_name -> Producer Name.
program_language -> Project Language.
shoot_location_country -> Shoot Country.
start_date -> YYYY-MM-DD
end_date -> YYYY-MM-DD
telecast_channel -> Channel Name.
type_of_genres -> Drama, Action, Comedy etc.
more_details -> Project Description.
meta_title -> SEO Title.
meta_keywords -> SEO Keywords.
meta_description -> SEO Description.
project_image -> Project Banner URL.
shoot_locations_json -> Location JSON Data.
Example: [{ "pincode":"110001", "addressLine1":"Connaught Place", "state":"Delhi", "district":"New Delhi"}]
locations_summary_json -> Location Summary JSON.
joget_user_id -> Owner User ID.
request_data -> Raw JSON Data.
status ->active inactive
created_by -> Admin User ID.
Note: Project ID must be unique. Do not change column names. `; }
if (activeTab === "roles") {
return ` Always download and use new sample file Steps to bulk upload Roles
1. Firstly, read notes carefully.
2. Download sample CSV file.
3. Create/Edit CSV file as explained below.
Note - * Indicates Mandatory Fields
audition_type * -> Online / Offline.
joget_role_id * -> Unique Role ID.
role_name * -> Role Name.
role_category * -> Main Cast / Supporting Cast.
project_joget_id -> Project ID.
shoot_location -> Shoot Location.
required_talent -> Actor / Model / Singer.
required_gender -> Male / Female / Other.
required_language -> Language Name.
required_nationality -> Nationality.
required_dialect -> Dialect.
required_experience_level -> Fresher Intermediate Experienced
required_skin_color -> Skin Colour.
required_age -> Example 18-25.
required_hair_color -> Hair Colour.
required_body_type -> Athletic / Slim.
required_waist_size -> Numeric Value.
required_chest_size -> Numeric Value.
required_hair_type -> Straight / Curly.
required_height -> Height in CM.
required_eye_color -> Eye Colour.
special_category -> Special Category.
sports_type -> Sports Skill.
esports_type -> Esports Skill.
driving_type -> Driving Skill.
people_appearance_list -> Appearance Type.
role_description -> Role Description.
role_scene -> Role Scene.
story_line -> Story Line.
character_sketch -> Character Sketch.
role_script -> Role Script.
meta_title -> SEO Title.
meta_keywords -> SEO Keywords.
meta_description -> SEO Description.
audition_locations_json -> JSON Location Data.
status -> active inactive
created_by -> Admin User ID.
joget_user_id -> Owner User ID.
request_data -> Raw JSON Data.
final_amount -> Numeric Amount.
Example: 50000
Note: Role ID must be unique. Do not change column names. `; }
    return "";
};
    return (
        <div className="migration-page">
            <div className="migration-header">
                <h2>CSV DATA MIGRATION HUB</h2>
                <p>Import your data securely and efficiently</p>
            </div>
            <Tabs
                activeKey={activeTab}
                onSelect={(k) => {
                    setActiveTab(k);
                    setFile(null);
                }}
                className="migration-tabs"
            >
                <Tab eventKey="users" title="Users (CSV)" />
                <Tab eventKey="projects" title="Projects (CSV)" />
                <Tab eventKey="roles" title="Roles (CSV)" />
            </Tabs>

         

        <Card className="migration-card">
    <Card.Body className="migration-card-body">
        <h3 className="migration-title">
    {activeTab.toUpperCase()} DATA MIGRATION
</h3>

<p className="migration-subtitle">
    Download sample file, prepare your CSV and import records securely.
</p>
        {/* Instruction Box */}
        {/* <Alert
    className="migration-guide-box mb-4"
    style={{ backgroundColor: "#f8d7da",  border: "1px solid #f5c2c7",borderRadius: "4px",padding: "20px"}}>
    <h5
        style={{
            color: "#842029",
            marginBottom: "20px",
            fontWeight: "500"
        }}
    >
        Always download and use new sample file
    </h5>

    <pre
        style={{
            whiteSpace: "pre-wrap",
            margin: 0,
            fontSize: "13px",
            lineHeight: "1.8",
            background: "transparent",
            border: "none",
            color: "#333"
        }}
    >
        {getMigrationGuide()}
    </pre>
</Alert> */}

<div className="migration-guide-box">

    <div className="migration-guide-header">
         CSV MIGRATION INSTRUCTIONS
    </div>

    <pre className="migration-guide-content">
        {getMigrationGuide()}
    </pre>

</div>
        <Button
            className="sample-download-btn"
            onClick={downloadSampleCsv}
        >
            <FiDownload />
            Download Sample CSV
        </Button>

       
        <input
            ref={fileInputRef}
            type="file"
            accept=".csv"
            hidden
            onChange={handleFileChange}
        />

        <div
            className="upload-drop-area"
            onClick={() => fileInputRef.current.click()}
        >
            <FiUploadCloud size={90} />

            <h5>Upload CSV File</h5>

            <p>Click here to browse CSV</p>
        </div>

        {file && (
            <div className="selected-file">
                <FiFileText />
                {file.name}
            </div>
        )}

        <Button
            variant="danger"
            onClick={handleMigrate}
            disabled={loading || !file}
            className="migration-import-btn"
        >
            {loading ? <Spinner size="sm" /> : `Import ${activeTab}`}
        </Button>

    </Card.Body>
</Card>
            

            <Alert className="migration-tip-box">
                <strong>Format Tip:</strong> Download a sample CSV from phpMyAdmin and ensure headers like <code>full_name</code>, <code>email</code>, and <code>mobile_no</code> are present.
            </Alert>
        </div>
    );
};

export default MigrationPage;